import { FormWarning } from 'components';
import { useTranslation } from 'react-i18next';

export default function CreditLimitWarningBox({
  creditLimit,
}: {
  creditLimit: number;
}) {
  const { t } = useTranslation('notification');
  return (
    <FormWarning
      title={t('ageRestriction.title', {
        creditLimit,
      })}
    />
  );
}
